import { PageContainer } from '@/components/containers/page-container';
import { PatientInfoSection } from '@/components/review/patient-info-section';
import { ConditionSection } from '@/components/review/condition-section';
import { PreferencesSection } from '@/components/review/preferences-section';
import { MedicalInfoSection } from '@/components/review/medical-info-section';
import { GradientFormTitle } from '@/components/containers/gradient-form-title';
import { NavButton } from '@/components/navigation/nav-button';
import { useEncounter } from '@/contexts/encounter-context';
import styles from './details-page.module.css';
import { useMediaQuery } from '@/hooks/use-media-query';
import { useTranslation } from '@/contexts/i18n-context';

const translationBase = 'visit.treatmentPlan.intakeDetails';

export function DetailsPage() {
  const { encounter } = useEncounter();
  const { t } = useTranslation();
  const isMobile = useMediaQuery('--screen-md');
  return (
    <PageContainer>
      {!isMobile && (
        <NavButton
          to={`/visit/${encounter.id}/tx-plan/treatment`}
          className={styles.backButton}
          text={`${translationBase}.backToTreatmentPlan`}
        />
      )}
      <GradientFormTitle withParagraphMargins={false}>
        {isMobile && (
          <NavButton
            to={`/visit/${encounter.id}/tx-plan/treatment`}
            text={`${translationBase}.backToTreatmentPlan`}
          />
        )}
        <h1 className="h3">{t(`${translationBase}.title`)}</h1>
      </GradientFormTitle>

      <PatientInfoSection showEditButton={false} showPaymentSection />

      <ConditionSection showEditButton={false} />

      <PreferencesSection showEditButton={false} />

      <MedicalInfoSection showEditButton={false} showNotALiveVisitDisclaimer={false} />
    </PageContainer>
  );
}
